import { JOB_STATUS_LABELS } from "../../../shared/serviceConstants";

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const STATUS_STYLES: Record<string, string> = {
  received: "bg-blue-50 text-blue-700 border border-blue-200",
  diagnosis: "bg-yellow-50 text-yellow-700 border border-yellow-200",
  pending_finance: "bg-purple-50 text-purple-700 border border-purple-300",
  awaiting_commercial_review: "bg-indigo-50 text-indigo-700 border border-indigo-200",
  ready_to_send_to_customer: "bg-sky-50 text-sky-700 border border-sky-200",
  awaiting_customer_confirmation: "bg-orange-50 text-orange-700 border border-orange-200",
  customer_declined: "bg-red-50 text-red-700 border border-red-200",
  in_progress: "bg-amber-50 text-amber-700 border border-amber-200",
  pending_parts: "bg-orange-50 text-orange-700 border border-orange-200",
  repair_complete: "bg-green-50 text-green-700 border border-green-200",
  awaiting_payment: "bg-pink-50 text-pink-700 border border-pink-200",
  awaiting_collection: "bg-purple-50 text-purple-700 border border-purple-200",
  closed: "bg-gray-50 text-gray-600 border border-gray-200",
};

export function StatusBadge({ status, className = "" }: StatusBadgeProps) {
  const style = STATUS_STYLES[status] || "bg-gray-50 text-gray-600 border border-gray-200";
  const label = JOB_STATUS_LABELS[status] || status;
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${style} ${className}`}
    >
      {label}
    </span>
  );
}
